import { render, staticRenderFns } from "./InnerPolicyDetail.vue?vue&type=template&id=36f04c70&"
import script from "./InnerPolicyDetail.vue?vue&type=script&lang=js&"
export * from "./InnerPolicyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports